import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const CTA: React.FC = () => {
  return (
    <section id="cta" className="cta-section">
      <div className="cta-container">
        <motion.div 
          className="cta-card"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <div className="cta-decoration-top-left"></div>
          <div className="cta-decoration-bottom-right"></div>
          
          <h2 className="cta-title pencil-text">
            Начните изучать языки по-новому
          </h2>
          <p className="cta-description pencil-text">
            Зарегистрируйтесь сейчас и откройте для себя контекстуальный подход к изучению языков.
          </p>

          <div className="cta-action-container">
            <Link to="/signin">
              <motion.button 
                className="cta-button pencil-outline"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Начать бесплатно
              </motion.button>
            </Link>
            <p className="cta-note pencil-text">
              Полностью бесплатно. Без обязательств.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
